import { render, staticRenderFns } from "./ModalAuth.vue?vue&type=template&id=588abc30&scoped=true&"
import script from "./ModalAuth.vue?vue&type=script&lang=js&"
export * from "./ModalAuth.vue?vue&type=script&lang=js&"
import style0 from "./ModalAuth.vue?vue&type=style&index=0&id=588abc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588abc30",
  null
  
)

export default component.exports